import type { LngLatBounds } from 'maplibre-gl';
import type { Coordinates } from '../types';
import maplibregl from 'maplibre-gl';

interface GetBoundsFromCenterParams {
	currentBounds: LngLatBounds;
	currentZoom: number;
	desiredCenter: Coordinates;
	desiredZoom: number;
}

/**
 * Returns the map bounds for a desired center and zoom level.
 * The output bounds match the viewport of the map using the current zoom level and center.
 */
export function getViewPortBoundsFromCenter({
	currentBounds,
	currentZoom,
	desiredCenter,
	desiredZoom,
}: GetBoundsFromCenterParams): LngLatBounds {
	// Calculate the scaling factor based on the desired zoom level
	const scale = 1 / 2 ** (desiredZoom - currentZoom);

	const center = currentBounds.getCenter();

	const dLng = currentBounds.getNorthEast().lng - center.lng;
	const dLat = currentBounds.getNorthEast().lat - center.lat;

	// Adjust the differences using the scaling factor
	const newDLng = dLng * scale;
	const newDLat = dLat * scale;

	// Calculate the new northeast and southwest corners based on the adjusted differences
	const newNELngLat = new maplibregl.LngLat(
		desiredCenter.lng + newDLng,
		desiredCenter.lat + newDLat,
	);
	const newSWLngLat = new maplibregl.LngLat(
		desiredCenter.lng - newDLng,
		desiredCenter.lat - newDLat,
	);

	return new maplibregl.LngLatBounds(newSWLngLat, newNELngLat);
}
